export default "__VITE_ASSET__ca3124fd__"